import type React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './operation-card.module.css';

interface OperationCardProps {
  icon: React.ReactNode;
  labelKey: string;
  descriptionKey?: string;
  selected?: boolean;
  disabled?: boolean;
  comingSoon?: boolean;
  hideDescription?: boolean;
  onClick: () => void;
}

export const OperationCard = ({
  icon,
  labelKey,
  descriptionKey,
  selected = false,
  disabled = false,
  comingSoon = false,
  hideDescription = false,
  onClick,
}: OperationCardProps) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      disabled={disabled}
      className={[
        styles.card,
        selected ? styles['card--selected'] : '',
        disabled ? styles['card--disabled'] : '',
      ].join(' ')}
      onClick={() => !disabled && onClick()}
    >
      <div className={styles['card-icon']}>{icon}</div>
      <div className={styles['card-content']}>
        <div className={styles['card-header']}>
          <span className={styles['card-name']}>{t(labelKey)}</span>
          {comingSoon && (
            <span className={styles['badge-soon']}>
              {t('backoffice.terminalsDrawerStepOperationComingSoon')}
            </span>
          )}
        </div>
        {!hideDescription && descriptionKey && (
          <span className={styles['card-description']}>{t(descriptionKey)}</span>
        )}
      </div>
    </button>
  );
};
